
import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonItem, IonButton, IonTextarea, IonInput } from '@ionic/vue';
import { useRoute,useRouter } from 'vue-router';
import axios from 'axios';
import useDataService from "../dataservice";

export default {
	name: 'TopicNew',
	components: {
		IonButtons,
		IonContent,
		IonHeader,
		IonMenuButton,
		IonPage,
		IonTitle,
		IonToolbar,
		IonItem,
		IonButton,
		IonTextarea,
		IonInput
	},
	methods: {
	},
  setup() {
    const route = useRoute();
    const router = useRouter();
    const folder = 'Создать новую тему форума';
	const { token } = useDataService();

	const forms = {title:'',text:''};
	
	const sendTopic = function(){
		if(forms.title.length > 3 && forms.title.length > 3){
			axios.post('https://beon.fun/api/v1/topic',{
				'title': forms.title,
				'text': forms.text,
				'forum': route.params.name
			},{
			headers: {
				Authorization: 'Bearer ' + token.value,
			}})
			.then((response) => {
				if(response.data.status == 'ok'){
					router.replace('/topic/' + response.data.topicid )
				}
			});
		}
	};

    return { folder, forms, sendTopic }
  }
}
